module.exports = "/_next/static/images/clear-0f24496b088360e96bf1b5552a91ac54.svg";